window.Vue = require('vue');
